"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftCandidateResultDto = instanceOfShiftCandidateResultDto;
exports.ShiftCandidateResultDtoFromJSON = ShiftCandidateResultDtoFromJSON;
exports.ShiftCandidateResultDtoFromJSONTyped = ShiftCandidateResultDtoFromJSONTyped;
exports.ShiftCandidateResultDtoToJSON = ShiftCandidateResultDtoToJSON;
exports.ShiftCandidateResultDtoToJSONTyped = ShiftCandidateResultDtoToJSONTyped;
const State_1 = require("./State");
const RequirementValidationResultDto_1 = require("./RequirementValidationResultDto");
/**
 * Check if a given object implements the ShiftCandidateResultDto interface.
 */
function instanceOfShiftCandidateResultDto(value) {
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('qualified' in value) || value['qualified'] === undefined)
        return false;
    return true;
}
function ShiftCandidateResultDtoFromJSON(json) {
    return ShiftCandidateResultDtoFromJSONTyped(json, false);
}
function ShiftCandidateResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'specialtyCode': json['specialtyCode'] == null ? undefined : json['specialtyCode'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'facilityId': json['facilityId'],
        'state': json['state'] == null ? undefined : (0, State_1.StateFromJSON)(json['state']),
        'qualified': json['qualified'],
        'validationResults': json['validationResults'] == null ? undefined : (json['validationResults'].map(RequirementValidationResultDto_1.RequirementValidationResultDtoFromJSON)),
    };
}
function ShiftCandidateResultDtoToJSON(json) {
    return ShiftCandidateResultDtoToJSONTyped(json, false);
}
function ShiftCandidateResultDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'specialtyCode': value['specialtyCode'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'facilityId': value['facilityId'],
        'state': (0, State_1.StateToJSON)(value['state']),
        'qualified': value['qualified'],
        'validationResults': value['validationResults'] == null ? undefined : (value['validationResults'].map(RequirementValidationResultDto_1.RequirementValidationResultDtoToJSON)),
    };
}
//# sourceMappingURL=ShiftCandidateResultDto.js.map